import { useDispatch } from 'react-redux'
import {
  actionGetInvoices,
  actionDropInvoices,
  actionResetInvoices,
} from 'modules/Finance/Invoices/store/actions'
import { useCallback } from 'react'

export const useInvoices = () => {
  const dispatch = useDispatch()

  const getInvoices = useCallback((props) => dispatch(actionGetInvoices(props)), [])

  const dropInvoices = useCallback((props) => dispatch(actionDropInvoices(props)), [])

  const resetInvoices = useCallback(() => dispatch(actionResetInvoices()), [])

  return {
    getInvoices,
    dropInvoices,
    resetInvoices,
  }
}
